const capitalizeString = (text: string): string => {
  return text[0].toUpperCase() + text.slice(1)
}

export default capitalizeString